<template>
    <div class="grid grid-cols-12 w-full  rounded-md py-1 px-3 items-center mb-2 text-[#001A72] bg-opacity-25">
        <div class="logo col-span-1 text-xs font-semibold ">
            {{ student.surname }} {{ student.name[0] + '.' }}
        </div>
        <div class="logo col-span-1 text-xs font-base text-center">
            {{ formatDate(student.birthday) }}
        </div>
        <div class="logo col-span-1 text-xs text-center">
            {{ student.group_name }}
        </div>
        <div class="logo col-span-1 text-xs text-center">
            {{ formatDate(student.start_training) }}
        </div>
        <div 
            class="logo col-span-1 text-xs text-center font-medium" 
            :class="{ 'text-[#F10265]' : studentBalance < 0, 'text-green-600' : studentBalance > 0, 'text-gray-600' : studentBalance == 0 }"
        >
            {{ studentBalance > 0 ? studentBalance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : (studentBalance * -1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}}
        </div>
        <div class="logo col-span-1 text-xs text-center">
            {{ student.player_number }}
        </div>
        <div class="logo col-span-1 text-xs text-center">
            {{ student.amplua }}
        </div>
        <div class="logo col-span-1 text-xs text-center">
            {{ 'Хабі' }}
        </div>
        <div class="logo col-span-1 text-xs text-center">
            {{ student.height.toString() + ' см'}}
        </div>
        <div class="logo col-span-1 text-xs text-center">
            {{ student.weight.toString() + ' кг' }}
        </div>
        <div class="logo col-span-1 text-xs text-center">
            {{ student.foot_size.toString() + ' р' }}
        </div>
        <div class="col-span-1 flex justify-end">
            <button @click="$emit('openStudentCard')" class=" rounded-md text-white text-xs px-0.5 py-0.5 font-medium">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.79934 15H8.20066C8.77098 15 9.217 14.6453 9.34878 14.0989L9.62961 12.876L9.81331 12.8124L10.8794 13.4663C11.3607 13.7672 11.9246 13.6918 12.3294 13.2842L13.3 12.321C13.7072 11.9084 13.78 11.3408 13.4795 10.8673L12.8148 9.80848L12.8827 9.63718L14.1021 9.34798C14.6424 9.21355 15 8.76402 15 8.19883V6.83521C15 6.27125 14.648 5.81921 14.1021 5.68608L12.8941 5.3912L12.8204 5.20858L13.4851 4.14974C13.7869 3.67625 13.7129 3.11428 13.3057 2.69608L12.335 1.72711C11.936 1.32523 11.372 1.2474 10.8908 1.54504L9.82463 2.19895L9.62961 2.12402L9.34878 0.901088C9.217 0.353495 8.77098 0 8.20066 0H6.79934C6.22896 0 5.78296 0.355983 5.65119 0.901088L5.3647 2.12402L5.16966 2.19895L4.10923 1.54504C3.62799 1.24989 3.05834 1.32523 2.65929 1.72711L1.6943 2.69608C1.2871 3.11428 1.2074 3.67625 1.51488 4.14974L2.1739 5.20858L2.10593 5.3912L0.897843 5.68608C0.349469 5.82046 0 6.27125 0 6.83521V8.19883C0 8.76402 0.357618 9.21485 0.897843 9.34798L2.11726 9.63718L2.17956 9.80848L1.52054 10.8673C1.21306 11.3408 1.29276 11.9084 1.69997 12.321L2.66495 13.2842C3.06967 13.6918 3.63932 13.7672 4.12056 13.4663L5.18099 12.8124L5.3647 12.876L5.65119 14.0989C5.78296 14.6453 6.22896 15 6.79934 15ZM6.97073 13.7475C6.85457 13.7475 6.79492 13.6979 6.77542 13.591L6.36599 11.8879C5.92857 11.7893 5.50877 11.6122 5.1745 11.3981L3.67882 12.3169C3.59719 12.3779 3.50989 12.3653 3.42949 12.2849L2.69285 11.5488C2.61687 11.4728 2.61369 11.3911 2.66646 11.2993L3.58821 9.81373C3.39828 9.48358 3.21374 9.06845 3.10821 8.6306L1.40658 8.22773C1.2998 8.20827 1.25021 8.14851 1.25021 8.03225V6.99612C1.25021 6.8742 1.29414 6.82135 1.40658 6.80064L3.10254 6.39211C3.21056 5.93285 3.41402 5.50262 3.57688 5.20332L2.6608 3.71772C2.60237 3.62026 2.6043 3.53855 2.68027 3.45685L3.42384 2.73216C3.50422 2.6517 3.5802 2.64036 3.67882 2.70008L5.16193 3.60187C5.47507 3.41482 5.93116 3.22708 6.37041 3.11082L6.77542 1.409C6.79492 1.30214 6.85457 1.25251 6.97073 1.25251H8.02921C8.14543 1.25251 8.20384 1.30214 8.21887 1.409L8.63525 3.12215C9.08334 3.23151 9.48486 3.41303 9.82675 3.60754L11.3117 2.70257C11.4173 2.64285 11.4864 2.65294 11.5737 2.73465L12.3103 3.45934C12.3919 3.54104 12.3894 3.62275 12.331 3.72021L11.4174 5.20332C11.5847 5.50138 11.7838 5.93285 11.8906 6.38963L13.5934 6.80064C13.7002 6.82135 13.7498 6.8742 13.7498 6.99612V8.03225C13.7498 8.14851 13.6933 8.20827 13.5934 8.22773L11.8849 8.63308C11.7793 9.06715 11.6005 9.4873 11.4061 9.81373L12.3241 11.2968C12.3781 11.3886 12.3806 11.4703 12.299 11.5464L11.568 12.2824C11.4795 12.3641 11.3991 12.3742 11.3117 12.3145L9.82233 11.3981C9.4818 11.6122 9.08634 11.7843 8.63525 11.8879L8.21887 13.591C8.20384 13.6979 8.14543 13.7475 8.02921 13.7475H6.97073ZM7.49938 10.1281C8.93664 10.1281 10.1183 8.9454 10.1183 7.50003C10.1183 6.06722 8.93664 4.88577 7.49938 4.88577C6.06212 4.88577 4.87351 6.06722 4.87351 7.50003C4.87351 8.94098 6.05646 10.1281 7.49938 10.1281ZM7.49938 8.94222C6.71259 8.94222 6.0653 8.29438 6.0653 7.50003C6.0653 6.71824 6.71383 6.07164 7.49938 6.07164C8.27362 6.07164 8.91961 6.72072 8.91961 7.50003C8.91961 8.28872 8.27362 8.94222 7.49938 8.94222Z" fill="#001A72"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted } from 'vue'
    import { getBalanceState } from '@/services/apiRequests'
    import { Skeletor } from 'vue-skeletor'

    export default {
        name: 'student-row',

        props: {
            student: {
                type: Object,
                required: true
            }
        },

        setup(props) {
            const studentLogo = ref(process.env.VUE_APP_API_URL + 'static/' + props.student.photo)
            const studentBalance = ref(0)

            onMounted(async () => {
                studentBalance.value = await getBalanceState(props.student.balance_id)
            })

            const formatDate = (date) => {
                const dateArray = date.split('-')
                return `${dateArray[2].slice(0, 2)}/${dateArray[1]}/${dateArray[0]}`
            }

            return {
                studentLogo,
                studentBalance,
                formatDate
            }
        },

        components: {
            Skeletor
        }
    }
</script>
